import React, { useState, useEffect, useRef } from 'react';
import { Typography, Stack, ToggleButton, ToggleButtonGroup, Select, MenuItem, TextField, Button, Box, Pagination, IconButton, FormHelperText } from "@mui/material";
import AWS from 'aws-sdk';
import { useQuery, useMutation, gql } from "@apollo/client";
import parser from 'html-react-parser';
import moment from 'moment';
import Taglistabb from '../components/Taglistabb';
import Grid from '@mui/material/Grid';
import Getuserinfodate from "../components/Getuserinfodate";
import Header from '../components/Header'
import GetImage from "../components/GetImage";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { NavLink, Link } from "react-router-dom";
import sortArray from 'sort-array';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { yellow, red } from '@mui/material/colors';
import emailjs from '@emailjs/browser';
import { Getname} from './Utils';

import "../components/formatlinks.css";

const blogquery = gql`
  query blogs {
    getpostscatsdate(accessgroups: ["staff","leadership","faculty"], posttype: ["blog","resource","story"], startdate: 1765774800000) {
     id
     title
     posttext
     author
     authoremail
     otherauthors
     postimage {
      filename
      fileext
      fileuuid
      filedate
      filelink
     }
     file {
      filename
      fileext
      fileuuid
      filedate
      filelink
     }
     tags
     posttype
     blog
     accessgroups
     response {
      responderemail
      responsetext
      responsedate
     }
     position
     createdAt
     archive
    } 
  }
`;

function viewlink(id, posttype) {
  return '/viewpostdirect/' + id + '/' + posttype[0];
}

const getWordStr = (mytext) => {
  let newvalue = mytext;
  if (newvalue.length>=375) {
    newvalue = newvalue.toString().substring(0,375) + ".....";
  }
  return newvalue;
}

const uv = (oldarray) => {
  const uniqueValues = [];
  oldarray.map((item) => {
    if (uniqueValues.indexOf(item) === -1) {
        uniqueValues.push(item)
    }
  });
  return uniqueValues;
}


function handleNewPostAction(latestPost) {
  // Your custom logic when a new post arrives
  alert(`New post published: ${latestPost.title}`);
  let textbody = "<html><head></head><body><div style='width:500px'>"
    + '<p>Karen</p>'
    + "<br/><img src='https://custoragepublic.nyc3.cdn.digitaloceanspaces.com/Nathaly.jpeg' /><br/><hr><br/><h3>New Post</h3>"
  //let textbody = "";
  textbody = textbody + "<div><p><a href='https://community.collegeunbound.edu" + viewlink(latestPost.id,latestPost.posttype) + "'>" +  latestPost.title + "</a></p>"
  + "<p>" + getWordStr(latestPost.posttext) + "</p><p>by " + latestPost.author + " on " + moment(parseFloat(latestPost.createdAt)).format('MM/DD/YY') + "</p></div><br/>"
  textbody = textbody + "</div></body></html>"
  console.log("textbody=", textbody);
  sendmail("community@collegeunbound.edu","New on the CU Community Site",textbody);
}

const sendmail = (to_email, subject, message) => {
  // initialize using your User ID saved in the .env file
  emailjs.init(process.env.REACT_APP_EMAIL_USER_ID);
  emailjs
    .send(
      process.env.REACT_APP_EMAIL_SERVICE_ID, // The service ID saved in the .env file
      process.env.REACT_APP_EMAIL_TEMPLATE_ID, // The template ID also saved in the .env file
      // Start of the variables defined in the template earlier
      {
        to_email: to_email,
        subject: subject,
        greeting: "Hello CU Core,",
        //bcc: "cucore@collegeunbound.edu",
        bcc: "michael.walker@collegeunbound.edu",
        message: message,
      }
      // End of the variables defined in the template earlier
    )
    .then((response) => {
      // Debug statement on the console to show the function has been executed successfully
      console.log(response);
    })
    .catch((error) => {
      // Debug statement on the console to show the error that occured
      console.log(error);
  });
}

function Foremail2() {
  const { data, loading, error } = useQuery(blogquery, {
    pollInterval: 60000, // Poll every 60 seconds
  });

  console.log("Karen");

  const prevPostsCountRef = useRef(0);

  useEffect(() => {
    if (data?.getpostscatsdate) {
      const currentCount = data.getpostscatsdate.length;
      console.log("currentCount=", currentCount);

      // Check if new posts were added
      if (prevPostsCountRef.current > 0 && currentCount > prevPostsCountRef.current) {
        const newPostsCount = currentCount - prevPostsCountRef.current;
        console.log(`New post detected! Count: ${newPostsCount}`);
        
        // Take your custom steps here (e.g., trigger toast notification, update state)
        handleNewPostAction(data.getpostscatsdate[currentCount-1]);
      }

      prevPostsCountRef.current = currentCount;
    }
  }, [data]);

  if (loading) return <p>Loading posts...</p>;
  if (error) return <p>Error loading posts.</p>;

  return (
    <div>
      {data.getpostscatsdate.map((post) => (
        <div key={post.id}>
          <h3>{post.title}</h3>
        </div>
      ))}
    </div>
  );
}

export default Foremail2;